<app-feedback-with-go-home
  iconType="warning"
  title="Temporarily unavailable"
  [textLines]="[
    'Sorry, the service is temporarily unavailable. Please try again later.'
  ]"
></app-feedback-with-go-home>
